<template>
  <div class="home">
    <div class="main">
      <BaseLockup class="lockup-p1"/>
      <BaseText8 :text="welcomeText"/>
    </div>
    <router-link to="/menu">
      <BaseButtonOctagon text="Enter" @click.native="$emit('start-audio')"/>
    </router-link>
  </div>
</template>

<script>
import BaseButtonOctagon from '@/components/BaseButtonOctagon/BaseButtonOctagon'
import BaseLockup from '@/components/BaseLockup/BaseLockup'
import BaseText8 from '@/components/BaseText8/BaseText8'
import { mapState } from 'vuex'
export default {
  name: 'home',
  components: {
    BaseButtonOctagon,
    BaseLockup,
    BaseText8
  },
  beforeDestroy () {
    localStorage.setItem('firstLoginComplete', true)
  },
  data: () => ({
    firstLoginComplete: localStorage.getItem('firstLoginComplete')
  }),
  computed: {
    ...mapState('user', {
      userProfile: state => state.userProfile
    }),
    welcomeText () {
      return !this.firstLoginComplete || this.userProfile.provider === 'guest'
        ? `Do you have what it takes?`
        : `Welcome back, ${this.userProfile.name}`
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: calc(var(--spacing-1) * 2);
  @media #{$media-3} {
    max-width: 27rem;
  }
}
.lockup-p1 {
  width: 100%;
  margin-bottom: 3rem;
}
.base-text-8 {
  line-height: 1.2em;
  @media #{$media-3} {
    font-size: 1.4rem;
  }
}
</style>
